import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  weeklychallengescon: [],
  weeklychallengecon: {}
}

const mutations = {  
  SET_WEEKLYCHALLENGES (state, payload) {
    state.weeklychallengescon = payload
  },
  SET_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallengecon = payload
  },
  ADD_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallengescon.push(payload)
  },
  DELETE_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallengescon.nuevos = state.weeklychallengescon.filter(element => {
      return element._id != payload
    })
  },
  CLOSE_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallengescon = state.weeklychallengescon.filter(element => {
      return element._id != payload._id
    })
  },
  SUBS_WEEKLYCHALLENGE (state, payload) {
    state.weeklychallengescon = state.weeklychallengescon.filter((element, ind) => {
      return ind != payload 
    })
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  weeklyChallengesConList: (context, id) => {
    return Vue.http.get(`${env.API}/api/weekly-challenge-con`)    
      .then((response) => {        
        context.commit('SET_WEEKLYCHALLENGES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getWccByIdPlan: (context, data) => {
    const { id, user } = data
    return Vue.http.get(`${env.API}/api/weekly-challenge-con/by-plan/${id}/${user}`)    
      .then((response) => {        
        context.commit('SET_WEEKLYCHALLENGES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createWCC: (context, data) => {
    return Vue.http.post(`${env.API}/api/weekly-challenge-con`, data)    
      .then((response) => {        
        context.commit('SET_WEEKLYCHALLENGES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getWCCById: (context, id) => {
    return Vue.http.get(`${env.API}/api/weekly-challenge-con/${id}`)    
      .then((response) => {        
        context.commit('SET_WEEKLYCHALLENGE', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },  
  addCommentToWeeklyChallengescon: (context, data) => {
    return Vue.http.post(`${env.API}/api/weekly-challenge-con/comment`, data)    
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommentsFromWeeklyChallengescon: (context, id) => {
    return Vue.http.get(`${env.API}/api/weekly-challenges-con/comments/${id}`)
    .then(response => {
        return response.body.message
    })
    .catch(error => {
        return context.commit('API_FAILURE', error)
    })
  },
  close: (context, id) => {
    return Vue.http.delete(`${env.API}/api/weekly-challenge-con/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  deleteWeeklyChallengescon: (context, id) => {
    return Vue.http.delete(`${env.API}/api/weekly-challenge-con/remove/${id}`)    
      .then((response) => {      
        context.commit('DELETE_WEEKLYCHALLENGE', response.body.commitment)       
        return response.body.success
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closeWeeklyChallengecon: (context, data) => {
    const { id, accomplished, planid } = data
    return Vue.http.put(`${env.API}/api/weekly-challenge-con/close/${id}`, { accomplished, planid })
      .then((response) => {
        context.commit('CLOSE_WEEKLYCHALLENGE', response.body.message)             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getWCClistByPlanConId: (context, data) => {
    return Vue.http.post(`${env.API}/api/weekly-challenge-con/by-plan-con`, data)    
      .then((response) => {
        context.commit('SET_WEEKLYCHALLENGES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateWeeklyChallengeCon: (context, data) => {
    return Vue.http.put(`${env.API}/api/weekly-challenge-con`, data)
      .then((response) => {             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateBWeeklyChallengeCon: (context, data) => {
    return Vue.http.put(`${env.API}/api/weekly-challenge-con/update/batch/wcc`, data)
      .then((response) => {             
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  addToWeeklyChallengeList: (context, data) => {
    context.commit('ADD_WEEKLYCHALLENGE', data)
    return true
  },
  subsToWeeklyChallengeList: (context, index) => {
    context.commit('SUBS_WEEKLYCHALLENGE', index)
    return true
  }
}

const getters = {
  getWeeklyChallengescon: (state) => state.weeklychallengescon,
  getWeeklyChallengecon: (state) => state.weeklychallengecon
}

export const weeklychallengecon = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/weekly_challenge_con.js